import {FeatureName} from '@hproduce/suite-core'
import React from 'react'
import {Outlet} from 'react-router'

import {useFeatureName} from '../features/useFeatureName'
import {InvalidSelectionPage} from '../InvalidSelectionPage'
import {useFeaturesMenu} from '../welcomeFlow/useFeaturesMenu'

import {findFeatureByName} from './findFeatureByName'
import {isHierarchyIndependentFeature} from './isHierarchyIndependentFeature'
import {useSelectedPlantUpmId} from './useSelectedPlantUpmId'

export const FeaturePlantAvailabilityGuard: React.FC = () => {
  const plantUpmId = useSelectedPlantUpmId()
  const featureName = useFeatureName()

  if (!plantUpmId || isHierarchyIndependentFeature(featureName)) {
    return <Outlet />
  }

  return <PlantScopedFeatureCheck plantUpmId={plantUpmId} featureName={featureName} />
}

const PlantScopedFeatureCheck: React.FC<{plantUpmId: string; featureName: FeatureName}> = ({
  plantUpmId,
  featureName
}) => {
  const {featuresMenu, isLoading, isFeatureMenuNotFound, isError} = useFeaturesMenu({plantUpmId})

  // the plant has no menu at all, so the feature cannot be available here
  if (isFeatureMenuNotFound) {
    return <InvalidSelectionPage variant="plant" />
  }

  // stay out of the way while loading or when the advisory lookup errors
  if (isLoading || isError || !featuresMenu) {
    return <Outlet />
  }

  if (findFeatureByName(featuresMenu, featureName)) {
    return <Outlet />
  }

  return <InvalidSelectionPage variant="plant" />
}
